"use client";

import { useEffect } from "react";
import { TreatmentName } from "@leafly-com/split-next/dist/custom-types";

import { useEventTracker } from "@/hooks/useEventTracker";

const SplitServerEvents: React.FC<{
  treatments: { [key in TreatmentName]?: string };
}> = ({ treatments }) => {
  const { publishEvent } = useEventTracker();

  useEffect(() => {
    Object.entries(treatments).forEach(([name, treatment]) => {
      publishEvent({
        action: "impression",
        category: `split test ${name}`,
        label: `group ${treatment}`,
      });
    });
  }, [JSON.stringify(treatments)]);

  return null;
};

export default SplitServerEvents;
